import React from "react"

import { contacts } from "../common/contacts"
import {Locales} from "../../../localization/types";

export const getData = (locale: Locales) => {
	if (locale === 'ru-KZ') {
		return  {
			blockName: "Часто задаваемые вопросы",
			title: "Что ещё рассказать?",
			questions: [
				{
					question: "Приложение бесплатно?",
					answer: (
						<div>
							Да, мобильное приложение для владельца ресторана Quick Resto Manager
							доступно на любом тарифе.
						</div>
					),
				},
				{
					question: "Как быстро в приложение попадают данные о последних продажах?",
					answer: (
						<div>
							В&nbsp;течение нескольких секунд после продажи. Чтобы увидеть
							последние показатели, нужно обновить запущенное приложение, потянув
							экран вниз.
						</div>
					),
				},
				{
					question:
						"Зачем мне приложение, если есть раздел «Виджеты» в бэк-офисе с графиками?",
					answer: (
						<div>
							Приложение покажет ключевые показатели бизнеса на&nbsp;экране
							смартфона.
						</div>
					),
				},
				{
					question: "Какие данные я могу получать через пуш-уведомления?",
					answer: (
						<div>
							Сообщение о&nbsp;закрытии смены с&nbsp;суммой выручки, подозрительных
							операциях по&nbsp;кассе (отмена пречека, возврат чека), складских
							остатках, чеках с&nbsp;применением фиксированной скидки, а&nbsp;также
							отзывах, оставленных посетителями через приложение для гостей.
						</div>
					),
				},
			],
		}
	} else if (locale === 'ru-BY') {
		return  {
			blockName: "Часто задаваемые вопросы",
			title: "Что ещё рассказать?",
			questions: [
				{
					question: "Приложение бесплатно?",
					answer: (
						<div>
							Да, мобильное приложение для владельца ресторана Quick Resto Manager
							доступно на любом тарифе.
						</div>
					),
				},
				{
					question: "Как быстро в приложение попадают данные о последних продажах?",
					answer: (
						<div>
							В&nbsp;течение нескольких секунд после продажи. Чтобы увидеть
							последние показатели, нужно обновить запущенное приложение, потянув
							экран вниз.
						</div>
					),
				},
				{
					question:
						"Зачем мне приложение, если есть раздел «Виджеты» в бэк-офисе с графиками?",
					answer: (
						<div>
							Приложение покажет ключевые показатели бизнеса на&nbsp;экране
							смартфона.
						</div>
					),
				},
				{
					question: "Какие данные я могу получать через пуш-уведомления?",
					answer: (
						<div>
							Сообщение о&nbsp;закрытии смены с&nbsp;суммой выручки, подозрительных
							операциях по&nbsp;кассе (отмена пречека, возврат чека), складских
							остатках, чеках с&nbsp;применением фиксированной скидки, а&nbsp;также
							отзывах, оставленных посетителями через приложение для гостей.
						</div>
					),
				},
			],
		}
	}

	return  {
		blockName: "Часто задаваемые вопросы",
		title: "Что рассказать еще?",
		questions: [
			{
				question: "Приложение бесплатно?",
				answer: (
					<div>
						Да, мобильное приложение для владельца ресторана Quick Resto Manager
						доступно на любом тарифе.
					</div>
				),
			},
			{
				question: "Как быстро в приложение попадают данные о последних продажах?",
				answer: (
					<div>
						В&nbsp;течение нескольких секунд после продажи. Чтобы увидеть
						последние показатели, нужно обновить запущенное приложение, потянув
						экран вниз.
					</div>
				),
			},
			{
				question:
					"Зачем мне приложение, если есть раздел «Виджеты» в бэк-офисе с графиками?",
				answer: (
					<div>
						Приложение покажет ключевые показатели бизнеса на&nbsp;экране
						смартфона.
					</div>
				),
			},
			{
				question: "Какие данные я могу получать через пуш-уведомления?",
				answer: (
					<div>
						Сообщение о&nbsp;закрытии смены с&nbsp;суммой выручки, подозрительных
						операциях по&nbsp;кассе (отмена пречека, возврат чека), складских
						остатках, чеках с&nbsp;применением фиксированной скидки, а&nbsp;также
						отзывах, оставленных посетителями через приложение для гостей.
					</div>
				),
			},
		],
	}
}
